<div
  class="custom-alert d-flex align-items-center"
  [ngClass]="{
    'alert-success-custom': type === 'success',
    'alert-danger-custom': type === 'danger'
  }"
  role="alert"
>
  <!-- Ícono -->
  <mat-icon
    class="alert-icon"
    [ngClass]="{
      'icon-success': type === 'success',
      'icon-danger': type === 'danger'
    }"
  >
    {{ type === "success" ? "check_circle" : "cancel" }}
  </mat-icon>

  <!-- Texto -->
  <div class="flex-grow-1 ms-2">
    {{ message }}
  </div>
</div>
